import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import { ExpandableText } from '@bibliocommons/expandable';

import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import QuotationDisplayContainer from 'app/components/bibs/shared/ugc/QuotationDisplay';
import { QuotationEditorContainer } from 'app/components/bibs/shared/ugc/QuotationEditor';
import { ugcSummaryShape } from 'app/shapes/bibPage';

import './Quotations.scss';

export default class Quotations extends React.PureComponent {
  renderQuotation = quotation => {
    return (
      <QuotationDisplayContainer
        quotation={quotation}
        catalogBib={this.props.catalogBib}
        handleDeleteSuccess={this.handleSuccess}
      >
        <ExpandableText
          text={quotation.get('quotation')}
          truncateCount={240}
          expandLinkHref={`#read-more-ugc-display-${quotation.get('id')}`}
          textKey="quotation"
        />
      </QuotationDisplayContainer>
    );
  };

  renderEditor = () => {
    return <QuotationEditorContainer catalogBib={this.props.catalogBib} handleSuccess={this.handleSuccess} />;
  };

  handleSuccess = () => {
    const metadataId = this.props.catalogBib.get('metadataId');
    this.props.bibsActions.fetchUGC(metadataId);
  };

  render() {
    const { quotations, quotationsTransactions, catalogBib } = this.props;
    const totalQuoteCount = this.props.summary?.getIn(['quotations', 'total']) ?? 0;
    const displayedQuoteCount = quotations.size;
    return (
      <div className="cp-quotations" data-key="quotations">
        <UgcList
          items={quotations}
          catalogBib={catalogBib}
          transactions={quotationsTransactions}
          renderItem={this.renderQuotation}
          renderEditor={this.renderEditor}
          contentType="quotations"
        />
        {totalQuoteCount > displayedQuoteCount && (
          <ChevronLink
            className="all-quotations"
            href={`/v2/record/${catalogBib.get('metadataId')}/quotations`}
            dataKey="all-quotations"
          >
            <FormattedMessage id="view_all_quotations" values={{ count: totalQuoteCount }} />
          </ChevronLink>
        )}
      </div>
    );
  }
}

Quotations.propTypes = {
  quotations: ImmutablePropTypes.list.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  summary: ugcSummaryShape,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogBib: catalogBibShape.isRequired
};
